import { ObserverService, ContentService, DavisAlertService } from "@DavisDigital/davisdigitalfrontend.module";
import { AccessAccount, AccessTypeSystemCode } from "@DavisDigital/interfaces";

export type ShareModalType = 'portfolio' | 'folder' | 'lesson';

class ShareSettingsModalController {
    
    private close:Function; //injected from modal-service
    
    public title: string;
    public tagQuery: string = '';
    public searchKeyword: string = '';
    
    public baseObjectId: string;
    public type: ShareModalType;
    public subType: string; //property added to differentiate folder and portfolioFolder 
    public shareWithClass: boolean;
    
    public baseObject:any;
    
    public activeTab: 'sharedWith' | 'addPeople' = 'sharedWith';
    
    
    public accountsWithAccess: AccessAccount[];
    public accountsWithoutAccess: AccessAccount[];
    
    public filteredSearchResults: AccessAccount[];
    public accountsWithoutAccessAndWithTags: AccessAccount[]
    
    public shareWithPublic:string = ""; // this is actually a boolean...
    public shareWithDistrict:string = "";
    public publicURL:string = "";
    public baseURL:string = "";
    public errors:any = [];
    public isLoading:boolean = false;
    public isGettingData:boolean = true;
    public isGettingClassData:boolean = false;
    public isGettingAccountData:boolean = true;
    public isSearchingTag:boolean = false;
    
    public publicURLInput: any;
    public sharingWithClass:boolean = false;
    public classList:any = [];
    public selectedClass:any = {};
    
    public showCopyLinkButton: boolean = false;
	
	//Bulk action properties
	public bulkAccessAction:string = '';
	public showBulkAssignConfirm:boolean = false;
	public showBulkRemoveConfirm:boolean = false;
	public maxKeywordLength:number = 3;
	public showResultsOnTagSearch:boolean = false;
	
	// @ngInject
	constructor(
		public $timeout         : ng.ITimeoutService,
		public contentService   : ContentService,
		private $window			: ng.IWindowService,
		public observerService  : ObserverService,
		private davisAlertService:DavisAlertService
	){}
	
	public $onInit = () => {
		this.isGettingClassData = this.shareWithClass;
        this.getShareAccountList();
        
        //initialize properties
        if( this.type=="portfolio") {
        	this.shareWithPublic = this.baseObject.sharedWithPublic;
        	this.shareWithDistrict = this.baseObject.sharedWithDistrict;
        	this.publicURL = this.baseObject.urlTitle;
        	this.baseURL = this.$window.location.origin;
        	this.showCopyLinkButton = !!this.shareWithPublic && !!this.publicURL && !!this.publicURL.trim();
        }
        
        if( this.shareWithClass ) {
        	this.getClassList();
        }
	}
	
	public onTabSelected = ( tab: 'sharedWith' | 'addPeople' ) => {
	    this.activeTab = tab;
	}
	
	public onRemoveAccountAccess = (account:AccessAccount) => {
        this.contentService
        .removeAccountAccessForShare(this.baseObjectId, account.account_accountID )
        .then( result => {
			if( !result.successfulActions?.length ) {
			    throw(result);
			}
			
			let removedItemIndex = this.accountsWithAccess.findIndex((item) => item.account_accountID == account.account_accountID);
			let removedAccount = this.accountsWithAccess.splice( removedItemIndex, 1 )?.[0];
			removedAccount.accessType_systemCode = 'accountAccessRead';
			this.accountsWithoutAccess.push(removedAccount);
			//udpates filter accounts list data
			this.setFilteredArray();
			
			this.davisAlertService.success("Account access has been removed.");
			
		});
		//TODO: success/errors	
	}
	
	private getAccessTypeFromSystemCode = (code: AccessTypeSystemCode): AccessTypeSystemCode => {
		return code === 'accountAccessAdminister' ? 'accountAccessWrite' : code;
	}
	
	private getShareTypeFromAccessSystemCode = (code: AccessTypeSystemCode): number => {
		return code === 'accountAccessAdminister' ? 2 : 0;
	}
	
	public onAssignAccountAccess = (account:AccessAccount) => {
	    let shareType = this.getShareTypeFromAccessSystemCode(account.accessType_systemCode);
	    let accessType = this.getAccessTypeFromSystemCode(account.accessType_systemCode);
	    
		this.contentService
		.assignAccountShareAccess(
		    account.account_accountID, 
		    this.baseObjectId, 
		    accessType, 
		    this.type,
		    shareType
		)
		.then( result => {
			if( !result.successfulActions?.length ) {
			    throw(result);
			}
			
			//once access is assigned, move the account to list with access
			let assignedItemIndex = this.accountsWithoutAccess.findIndex((item) => item.account_accountID == account.account_accountID);
			let assignedAccount = this.accountsWithoutAccess.splice( assignedItemIndex, 1 )?.[0];
			
			//set default share type 
			assignedAccount['shareType'] = shareType;
			assignedAccount.accessType_systemCode = accessType;
			
			this.accountsWithAccess.push(assignedAccount);
			//udpates filter accounts list data
			//if it was a tag search make the api call again to get the updated list after sharing with one account
			if(!this.tagQuery){
				this.setFilteredArray();
			}else{
				this.getAccountsListForShareWithTag();
			}
			
			this.davisAlertService.success("Access has been assigned on the account.");
		});
		
		//TODO: success/errors
	}
	
	public setShowBulkAssignConfirm = (action: boolean = true) => {
		if( this.bulkAccessAction == "") {
			return;
		}
		//show confirm message
		this.showBulkAssignConfirm = action;
	}
	
	public setShowBulkRemoveConfirm = (action: boolean = true) => {
		//show confirm message
		this.showBulkRemoveConfirm = action;
	}
	
	public onSubmitBulkAccountShare = () => {
		
		if( this.isLoading ) {
			return;
		}
		
		this.isLoading = true;
		
		//get selected account IDs
		let selectedAccountIDs = [];
		for(let account of this.filteredSearchResults){
			selectedAccountIDs.push(account.account_accountID);
		}
		
		//call API
		this.contentService.assignAccountBulkShareAccess(
		    selectedAccountIDs.join(), 
		    this.baseObjectId, 
		    this.bulkAccessAction, 
		    this.type
		)
		.then( result => {
			this.onCloseModal();
		}).finally(() =>{
			this.isLoading = false;
		});
		
	}
	
	public onSubmitBulkAccountRemove = () => {
		
		if( this.isLoading ) {
			return;
		}
		
		this.isLoading = true;
		
		//call API
		this.contentService.removeBulkShareAccess(this.baseObjectId)
		.then( result => {
			this.onCloseModal();
		}).finally(() =>{
			this.isLoading = false;
		});
		
	}
	
	public onCloseModal = () =>{
		this.close();
	}
	
	public onSubmitShare = () => {
		//return if isLoading is already true (it means another call is in process)
		if(this.isLoading){
			return;
		}
		//If It is Portfolio share
		if(this.type=="portfolio") {
			this.errors = [];
			
			//Validate URL if sharedWithPublic
			if( this.shareWithPublic && !this.publicURL) {
				this.errors.push("URL is required");
				return;
			}
			
			//set isLoading to true (to prevent any other API call)
			this.isLoading = true;
			this.cleanPublicURL();
			this.contentService.shareSettingsUpdate(this.baseObjectId, this.shareWithDistrict, this.shareWithPublic, this.publicURL).then( (result)=>{
				this.isLoading = false;
				if(result.errors?.portfolio) {
					this.davisAlertService.error(result.errors.portfolio);
				}
				if( result.successfulActions?.length ) {
					if( this.shareWithPublic ) {
						this.showCopyLinkButton = true;
					}
					this.davisAlertService.success("Record has been updated successfully!.");
					this.onCloseModal();
				}
			});
		
		} else {
			this.onCloseModal();
		}
		
	}
	
	public onCopyShareLink(): void {
		/* Get the text field */
		let input: HTMLInputElement = document.createElement('input');
		input.type = "text";
		input.className = 'hidden';
		input.value = `${window.location.origin}/${this.publicURL}`;
        document.body.appendChild(input);
		/* Select the text field */
		input.select();
		input.setSelectionRange(0, 99999); /* For mobile devices */
		
		/* Copy the text inside the text field */
		document.execCommand("copy");
        document.body.removeChild(input);
	}
	
	private setFilteredArray = (filteredAccounts = []) => {
		if(filteredAccounts.length == 0 && this.tagQuery === ''){
			this.filteredSearchResults = this.accountsWithoutAccess
			this.accountsWithoutAccessAndWithTags = this.accountsWithoutAccess
		}else{
			this.accountsWithoutAccessAndWithTags = filteredAccounts
		}
		this.searchAccounts()
	}
	private searchAccounts = () =>{
		if(this.searchKeyword.length < this.maxKeywordLength && this.tagQuery.length == 0) return;
		this.filteredSearchResults = this.accountsWithoutAccessAndWithTags.filter(account => (account.account_firstName.toLowerCase().includes(this.searchKeyword.toLowerCase()) 
		|| account.account_lastName.toLowerCase().includes(this.searchKeyword.toLowerCase()) || account.account_primaryEmailAddress_emailAddress.toLowerCase().includes(this.searchKeyword.toLowerCase())))
		
	}
	
	private getAccountsListForShareWithTag = () =>{
		this.showResultsOnTagSearch = false;
		var data = {};
		if(this.tagQuery){
			data['tagName'] = this.tagQuery 
		}else{
			this.setFilteredArray()
			return
		}
		data['accountIDList'] = this.accountsWithoutAccess.map((account)=>{
			return account.account_accountID
		}).join(',')
		this.isSearchingTag = true;
		this.contentService.getAccountsListForShareWithTag(data).then(result => {
			const accountsWithTag = result.data.accountsWithTag;
			const filteredAccount = this.accountsWithoutAccess.filter((account)=>{
				return accountsWithTag.includes(account.account_accountID)
			})
			this.showResultsOnTagSearch = filteredAccount.length > 0;

			this.setFilteredArray(filteredAccount);
			this.isSearchingTag=false;
		});
	}
	private getShareAccountList = () => {
		var data = {};
		if( this.type == "lesson"){
			data['lessonID'] = this.baseObjectId;
		} 
		else if(this.type == "folder"){
			data['folderID'] = this.baseObjectId;
			
			if( this.subType == "portfolioFolder") {
				data['ignoreStudentAccounts'] = true;
			}
		}
		else if(this.type == "portfolio"){
			data['portfolioID'] = this.baseObjectId;
		}

		this.contentService.getAccountsListForShare(data).then(result => {
			this.accountsWithAccess = result.data.accountsWithAccess;
			this.accountsWithoutAccess = result.data.accountsWithoutAccess;
			this.accountsWithoutAccess.forEach( a => a.accessType_systemCode = "accountAccessRead" );
			this.setFilteredArray();
			this.isGettingAccountData = false;
			if (!this.shareWithClass || !this.isGettingClassData) {
				this.isGettingData = false;
			}
		});
	}
	
	public cleanPublicURL(): void {
		let url = this.publicURL;
		if (!url || !url.length || !url.trim().length) {
			url = this.baseObject.title;
		}
		url = url.replace(/[^a-zA-Z0-9\s-]/g, '').replace(/[\s]/g, '-');
		this.publicURL = url;
		this.showCopyLinkButton = false;
	}
	/**
	 * Method to get class list on init
	 * */
	private getClassList() {
		this.contentService.getClassListForShare().then(result => {
			this.classList = result.data;
			this.isGettingClassData = false;
			if (!this.isGettingAccountData) {
				this.isGettingData = false;
			}
		});
	}
	
	/**
	 * Method when class is selected from UI
	 * */
	public onClassSelected(classObject: any = {}) {
		this.selectedClass = classObject;
	}
	
	/**
	 * Method to be used for enabling / disabling class list view
	**/
	public onShareWithClass = (sharing:boolean = true) => {
		this.sharingWithClass = sharing;
		this.onClassSelected();
	}
	
	/**
	 * Method to share with class submissions
	 **/ 
	public onShareWithClassSubmit() {
		if( this.isLoading ) {
			return;
		}
		
		this.isLoading = true;
		
		//call API
		this.contentService.shareWithClass(
		    this.baseObjectId, 
		    this.type,
		    this.selectedClass.schoolCourseID
		)
		.then( result => {
			this.onCloseModal();
		}).finally(() =>{
			this.isLoading = false;
		});
	}
}
    

class ShareSettingsModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    title: "<",
	    baseObjectId: "<",
	    type: "<",
	    subType: "<?",
	    shareWithClass: "<",
	    baseObject: "<",
		close:'='
	};

	public controller = ShareSettingsModalController;
	public controllerAs = 'shareModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/share-settings-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ShareSettingsModal };
